<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Button, ButtonGroupV2, Text } from '@Shelly/shelly-design-system';

	export let typeValue;

	let options = ['button', 'switch'];
	let _options = [
		$format('working_type_button', { default: 'Button' }),
		$format('working_type_switch', { default: 'Switch' }),
	];

	let value = typeValue;
	$: typeValue = value;

	$: typeLabel = formatSnakeCaseToTitle(
		$format('btn_type_label', { default: 'select input button/switch mode' }),
	);
</script>

<Text class="text-bold mb-s">
	{typeLabel}
</Text>
<ButtonGroupV2
	fullWidth
	noWrap
	orientation="horizontal"
	id="buttongroup-input-type-reader"
	aria-label={typeLabel}
>
	{#each options as option, i (option)}
		<Button
			class={value === option ? 'active' : undefined}
			size="m"
			on:click={() => (value = option)}
		>
			{_options[i]}
		</Button>
	{/each}
</ButtonGroupV2>
